import { useState, useRef } from "react";
import Config from "../../Config";


import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";

import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputCombo from "../../helpers/InputCombo";
import InputLegend from "../../helpers/InputLegend";
import InputComboGrupa from "../../helpers/InputComboGrupa";

import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";


import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";

import trash from "../../trash.png";
 

 
 
import InputComboDzien from "../../helpers/InputComboDzien";
import MenuTable from "../../helpers/MenuTable";
import AppContext from "../../AppContext";
import SortBy from "../../helpers/SortBy";
import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";



function Sms(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        fraza:  ''  ,
        r_imie_nazwisko: props.mainView.readFilter('r_imie_nazwisko',''), 
        data_od:  ''  ,
        data_do:  ''  ,
        limit: 50,
        page: 1,
        pages: 1,
        show: true,

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

    });
    const [tab, setTab] = useState(null);

    const [selectedRow, setSelectedRow] = useState([]);

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );



   // const [legend, setLegend] = useState([
   //     {
       //     cls:'color_show1',
        //    title: 'Wejście lub wyjście wirtualne - systemowe',
       //
       // },
    //]);


 





    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_rap,smsy', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );                              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

  

    const valChangeListener = (filedName, val, correct, msg) => {

       // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }



    const filterClear = () => {

        props.mainView.writeFilter('r_imie_nazwisko', '');  

        setFilterParam({          
            fraza: '',            
            r_imie_nazwisko: '',            
            data_od: '',            
            data_do: '',            
            limit: 50,
            page: 1,
            pages: 1,
            show: true,

            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },
        });
        setTab(null);
 
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }

 

    
    if(tab == null)
        {
            setTab([]);
            getTab();
         
    
            return <div>
                ...
            </div>
        }
    
    
        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            setView( {
                v:'list',
                id: -1
            });
        }


 


    var sortList = [                         
        {column: "created_at", name: "Data wysyłki"  },
]


    var sumSms = 0;

    for(var k =0; k < tab.length; k++)
    {
        sumSms = parseInt( sumSms) + parseInt( tab[k]["ilosc_sms"]);
    }



    return (

        <div className="view_content">



                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                {
                    filterParam.show == true  &&
                    <div className="table_filter">
 

                    <div className="filter_controll">   
                                <label>Nazwisko, imię: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.r_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="r_imie_nazwisko" placeholder={"Osoba: "}   />
                    </div>  
    
    
                    <div className="filter_controll">   
                        <label>Fraza: </label>                             
                        <InputText   userData={props.userData} value={filterParam.fraza}   valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"Fraza: "}   />
                    </div>  
    
    
                    <div className="filter_controll filter_merge">   
                                <label>Data wysłania (od dnia / do dnia): </label>      <br/>                       
                                <InputDate   userData={props.userData} value={filterParam.data_od}   valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={"Od dnia: "}   />                                                                  
                                <InputDate   userData={props.userData} value={filterParam.data_do}   valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={"Do dnia: "}   />
                    </div> 

               
                    <div className="filter_btn">
                                    <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                    <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                    </div>
    
                </div>
                } 

         
         



            <div className="table_widget">

                                                                    
 

                            <InputPagger filter={filterParam}  onChange={onChangePagger}  />
       

                            &nbsp;&nbsp;                              

                       

                            <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
            </div>

 


            <div className="bg_center">

 
 
                <div className="scorll_x">
                            <table className="table" >
                                <thead>
                                    <tr className="header">
                                        <td className="td_left">LP</td>                                                                            
                                        <td>Nazwisko, imię</td>    
                                        <td>Telefon</td>    
                                        <td>Data</td>    
                                        <td>Wiadomość</td>
                                        <td className="td_right">Ilość sms</td>
                                     
                                    </tr>
                                </thead>


                                <tbody>
                                                {
                                                    tab.map( (row, ix)=>{
                                                                                                                 
                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                        return <tr className={ rowStyle } key={ix+1}>
                                                            <td className="gocenter">{ix+1}</td> 
                                                            <td className="gocenter">{row.osoba.nazwisko} {row.osoba.imie}</td>
                                                            <td className="gocenter">{row.numer_odbiorcy}</td>
                                                            <td className="gocenter">{row.created_at}</td>                                                      
                                                            <td>{row.wiadomosc}</td>                                                                                                              
                                                            <td className="gocenter">{row.ilosc_sms}</td>                                                                                                              
                                                        </tr>
                                                    } )
                                                }    

                                                       <tr >
                                                            <td className="gocenter"> </td> 
                                                            <td className="gocenter"> </td>
                                                            <td className="gocenter"> </td>                                                      
                                                            <td> </td>                                                                                                              
                                                            <td className="gocenter gobold">{sumSms}</td>                                                                                                              
                                                        </tr>
                                </tbody>
                                
                            </table>
                </div>

            </div>


        </div>
    )
}


export default Sms;